import { render, staticRenderFns } from "./FlipBoard.vue?vue&type=template&id=f709360a&scoped=true&"
import script from "./FlipBoard.vue?vue&type=script&lang=js&"
export * from "./FlipBoard.vue?vue&type=script&lang=js&"
import style0 from "./FlipBoard.vue?vue&type=style&index=0&id=f709360a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f709360a",
  null
  
)

export default component.exports